module.exports = __webpack_public_path__ + "img/jordan-river.33b10c5a.svg";